/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTeamUsedChannels
 */
export interface OutputTeamUsedChannels {
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputTeamUsedChannels
     */
    channels: Array<string>;
}

/**
 * Check if a given object implements the OutputTeamUsedChannels interface.
 */
export function instanceOfOutputTeamUsedChannels(value: object): boolean {
    if (!('channels' in value)) return false;
    return true;
}

export function OutputTeamUsedChannelsFromJSON(json: any): OutputTeamUsedChannels {
    return OutputTeamUsedChannelsFromJSONTyped(json, false);
}

export function OutputTeamUsedChannelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTeamUsedChannels {
    if (json == null) {
        return json;
    }
    return {
        
        'channels': json['channels'],
    };
}

export function OutputTeamUsedChannelsToJSON(value?: OutputTeamUsedChannels | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channels': value['channels'],
    };
}

